<template>
<div>
	<div v-if="isMobile">
		<Mobile />
	</div>
	<div v-if="!isMobile">
		<Pc />
	</div>
</div>
</template>

<script>
	import Mobile from './Mobile.vue'
	import Pc from './Pc.vue'
	import {
		mapState,
	} from 'vuex'
	export default {
		data() {
			return {

			}
		},
		computed: {
			...mapState(['isMobile'])
		},
		components: {
			Mobile,Pc
		}
	}
</script>

<style lang="scss" scoped>

</style>